import React , {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
class ProductCardLoader extends Component{
    render(){
        return(
            <div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-custom-4">
                    <div className="row no-gutters">
                        <div className="col-auto pl-1">
                            <Skeleton count={1} height={100} width={100}/>
                        </div>
                        <div className="col pr-1">
                            <div className="row no-gutters flex-column justify-content-between  h-100">
                                <div>
                                    <div className="mb-2">
                                        <Skeleton count={1} height={10} width={100}/>
                                    </div>
                                    <div>
                                        <Skeleton count={1} height={5} width={200}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="row no-gutters justify-content-between">
                                        <div className="col-auto">
                                            <Skeleton count={1} height={5} width={50}/>
                                        </div>
                                        <div className="col-auto">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}


export default ProductCardLoader;